<page-toolbar [pageActions]="pageActions" [title]="this.title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (custom)="onCustom($event)" (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)"
              *ngIf="!isLoading" [columns]="columns" [dataProviderParams]="params" [dataProvider]="redirectService" [title]="title"
              [searchColumns]="searchColumns" icon='receipt'></data-table>
</page-content>

